import { render, staticRenderFns } from "./transactionAdminQuit.vue?vue&type=template&id=2a59fe66&scoped=true&"
import script from "./transactionAdminQuit.vue?vue&type=script&lang=js&"
export * from "./transactionAdminQuit.vue?vue&type=script&lang=js&"
import style0 from "./transactionAdminQuit.vue?vue&type=style&index=0&id=2a59fe66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59fe66",
  null
  
)

export default component.exports